import React, { useState, useEffect, useRef } from "react";
import "./receipt.css";
import logo from "./img/logo.png";
import QRCode from "qrcode";
import html2pdf from "html2pdf.js";
import { Delete, Download } from "react-feather";
// import signature from "./img/signature.png";

function Receipt() {
  const [formData, setFormData] = useState({
    Names: "",
    Faculty: "",
    Department: "",
    Class: "",
    Matricule: "",
    "Academic year": "",
    Amount: "",
    reason: "",
    source: "",
    date: "",
    ref: "",
    image: null,
  });

  const [receipts, setReceipts] = useState([]);
  const [showReceipt, setShowReceipt] = useState({});

  // Load receipts from localStorage on component mount
  useEffect(() => {
    const storedReceipts = localStorage.getItem("receipts");
    if (storedReceipts) {
      setReceipts(JSON.parse(storedReceipts));
    }
  }, []);

  // Save receipts to localStorage whenever they are updated
  useEffect(() => {
    localStorage.setItem("receipts", JSON.stringify(receipts));
  }, [receipts]);

  const handleChange = async (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = () => {
        setFormData((prevData) => ({
          ...prevData,
          [name]: reader.result, // Save Base64 string of the image
        }));
      };
      if (file) reader.readAsDataURL(file);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleCreateReceipt = () => {
    if (formData.Names.trim() === "") {
      alert("Name field cannot be empty!");
      return;
    }
    setReceipts([...receipts, { ...formData }]);
    setShowReceipt((prev) => ({ ...prev, [formData.Names]: false }));
    setFormData({
      Names: "",
      Faculty: "",
      Department: "",
      Class: "",
      Matricule: "",
      "Academic year": "",
      Amount: "",
      reason: "",
      source: "",
      date: "",
      ref: "",
      image: null,
    });
  };

  const handleDeleteReceipt = (index) => {
    const updatedReceipts = receipts.filter((_, i) => i !== index);
    setReceipts(updatedReceipts);
  };

  const toggleReceiptView = (name) => {
    setShowReceipt((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  return (
    <div className="recu">
      <div>
        <input
          className="finput"
          type="text"
          name="Names"
          placeholder="Nom et prenom"
          value={formData.Names}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Faculty"
          placeholder="Faculty"
          value={formData.Faculty}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Department"
          placeholder="Department"
          value={formData.Department}
          onChange={handleChange}
        />
        <br />
        <input
          className="finput"
          type="text"
          name="Class"
          placeholder="Class"
          value={formData.Class}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Matricule"
          placeholder="Matricule"
          value={formData.Matricule}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="Academic year"
          placeholder="Anée Académique"
          value={formData["Academic year"]}
          onChange={handleChange}
        />
        <br />
        <input
          className="finput"
          type="text"
          name="Amount"
          placeholder="Montant"
          value={formData.Amount}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="reason"
          placeholder="Motif"
          value={formData.reason}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="source"
          placeholder="Source de paiement (ex: Western Union)"
          value={formData.source}
          onChange={handleChange}
        />
        <br />
        <input
          className="finput"
          type="date"
          name="date"
          placeholder="Date"
          value={formData.date}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="text"
          name="ref"
          placeholder="N° de Reference"
          value={formData.ref}
          onChange={handleChange}
        />
        <input
          className="finput"
          type="file"
          name="image"
          id="f-img"
          accept="image/*"
          onChange={handleChange}
        />
        <br />
        <div className="fbtn">
          <button className="fbutton" onClick={handleCreateReceipt}>
            Créer reçu
          </button>
        </div>
      </div>

      <div className="receipt-list">
        {receipts.map((receipt, index) => (
          <div key={index} className="receipt-item">
            <button
              className="receipt-toggle"
              onClick={() => toggleReceiptView(receipt.Names)}
            >
              {receipt.Names}
            </button>
            <button
              className="delete-btn"
              onClick={() => handleDeleteReceipt(index)}
            >
              <Delete size={15} />
            </button>
            {showReceipt[receipt.Names] && (
                <div>
              <ReceiptTemplate formData={receipt} />
              <button
              className="downbtn"
              onClick={() => downloadPDF(receipt.Names)}
            >
             Telecharger <Download size={15} />
            </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

const ReceiptTemplate = ({ formData }) => {
  const now = new Date().toLocaleDateString();
  const qrCodeRef = useRef();

  useEffect(() => {
    const generateQRCode = async () => {
      const qrData = `
        Name: ${formData.Names}
        Faculty: ${formData.Faculty}
        Department: ${formData.Department}
        Class: ${formData.Class}
        Matricule: ${formData.Matricule}
        Amount: ${formData.Amount}
        Reason: ${formData.reason}
        Date: ${formData.date}
        Ref: ${formData.ref}
        Verification: Receipt Confirmed
      `;
      const qrCodeUrl = await QRCode.toDataURL(qrData);
      qrCodeRef.current.src = qrCodeUrl;
    };
    generateQRCode();
  }, [formData]);

  return (
    <div className="recu-body" id={`receipt-${formData.Names}`}>
      <div className="school-pic">
        <div className="frecu">
          <h4>
          UNIVERSITÉ DE MANONO
          </h4>
          <img src={logo} alt="University Logo" />
          <p>
            Scientia splendet et conscientia
            <br />
            <span>
              <strong>Status :</strong> Université publique
              <br />
              <strong>Web :</strong> universitedemanono.net
              <br />
              <strong>Email :</strong> info@universitedemanono.net
            </span>
          </p>
        </div>
        {formData.image && (
          <img src={formData.image} alt="Student" className="stu-pic" />
        )}
      </div>
      <p className="stup">
        Reçu de : <strong>{formData.Names} </strong>
        le somme de: <strong>{formData.Amount} </strong>
        versée le <strong>{formData.date} </strong><br /> pour :{" "}
        <strong>{formData.reason} </strong>  à :{" "}
        <strong>{formData.source}</strong> N°/Ref <strong>{formData.ref}</strong>{" "}
        <br />a été
        vérifiée et confirmée par le service de comptabilité du U.M.A le :{" "}
        <strong>{now}</strong>
        <br />
        <br />
        <br />
        <div style={{display: "flex", marginBottom: "-15px"} }>
          <div>
            <span><b>Signature:</b></span>
          </div>
          <div>
            {/* <img src={signature} width={100}/> */} {/* remember to unlock it at the top */}
          </div>
        </div>
          {/* <span style={{marginTop: "-35px"}}>
            Nom du comptable:
            <br />
            Secrétaire-Comptable-Logistique du U.M.A
          </span> */}
      </p>
      <div className="qr-container">
        <img ref={qrCodeRef} alt="QR Code" className="qr-code" />
      </div>
    </div>
  );
};

const downloadPDF = (name) => {
  const element = document.getElementById(`receipt-${name}`);
  const options = {
    margin: 1,
    filename: `${name}_receipt.pdf`,
    html2canvas: { scale: 2, x : -2, y: 0, backgroundColor: "none" },
    jsPDF: { format: "a4", orientation: "portrait" },
  };
  html2pdf().set(options).from(element).save();
};

export default Receipt;
